import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AccountResponseDto,
  AccountSettingResponseDto,
  AsyncThunkConfig,
  ECGWaveFormResponseDto,
  PatientResponseDto,
  RequestResponseDto,
} from 'types/types';
import {
  getPaginatedRequests as getRequests,
  updateRequest as _updateRequest,
} from 'api/controllers/request-controller';
import { RequestPaginatedResponseDto } from 'types/types';
import { getAccountById, getAccountSettings } from 'api/controllers/account-controller';
import { getECGCaptureByPatientId } from 'api/controllers/ecg-capture-controller';
import { getPatientById } from 'api/controllers/patient-controller';
import { requestsActions } from '.';
import { AccountSettingType } from 'types/enums';

const getPaginatedRequests = createAsyncThunk<RequestPaginatedResponseDto, void, AsyncThunkConfig>(
  'requests/getPaginatedRequests',
  async (_, { getState }) => {
    const { limit, skip, statusSort, dateSortOrder, statusFIlter } = getState().requests;

    return await getRequests(limit, skip, statusSort, dateSortOrder, statusFIlter);
  },
);

const getAccountData = createAsyncThunk<AccountResponseDto, string, AsyncThunkConfig>(
  'requests/getAccountData',
  async (id) => {
    return await getAccountById(id);
  },
);

const getPatientsData = createAsyncThunk<PatientResponseDto, string, AsyncThunkConfig>(
  'requests/getPatientsData',
  async (id) => {
    const captures = await getPatientById(id);

    return captures;
  },
);

const getPatientEcgCaptures = createAsyncThunk<ECGWaveFormResponseDto[], string, AsyncThunkConfig>(
  'requests/getPatientEcgCaptures',
  async (patientId) => {
    return await getECGCaptureByPatientId(patientId, 15);
  },
);

const updateRequest = createAsyncThunk<void, RequestResponseDto, AsyncThunkConfig>(
  'requests/updateRequest',
  async (request, { dispatch }) => {
    await _updateRequest(request);
    dispatch(getPaginatedRequests());
    dispatch(requestsActions.clearAnalyzedData());
  },
);

const getAccountNotificationSettings = createAsyncThunk<AccountSettingResponseDto[], string, AsyncThunkConfig>(
  'requests/getAccountNotificationSettings',
  async (accountId) => {
    const response = await getAccountSettings(accountId);

    const notificationSettings = response.filter(({ type }) => type === AccountSettingType.NOTIFICATION);

    return notificationSettings;
  },
);

export {
  getPaginatedRequests,
  getAccountData,
  getPatientsData,
  getPatientEcgCaptures,
  updateRequest,
  getAccountNotificationSettings,
};
